module.exports = __webpack_public_path__ + "img/hs-04.be02d3b1.svg";